import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom-v5-compat';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import NullState from 'dashboard/components-lib/NullState';
import { Backdrop } from 'dashboard/layouts/ShowViewLayoutV2';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { useGetExternalWorkflowStepQuery } from 'dashboard/redux/api/workflow-step';
import useRTKErrorHandler from 'lib/hooks/useRTKErrorHandler';

type Params = { workflowStepId: string };

const DashboardWorkflowRunStepsRoute: FC = () => {
  const { workflowStepId } = useParams<Params>() as Params; // workflowStepId will always be a defined
  const navigate = useNavigate();
  const {
    data: { data: workflowStep } = {},
    isLoading,
    error,
  } = useGetExternalWorkflowStepQuery(workflowStepId);

  useRTKErrorHandler({
    error,
    onError: (error) => ({
      message: error?.errors?.at(0)?.title || 'An error occurred loading the Workflow Step',
      level: MessageType.Failure,
    }),
  });

  const workflowRunId = workflowStep?.relationships['workflow-run'].data.id;
  useEffect(() => {
    if (workflowRunId) {
      // TODO(Evan): Link directly to the Workflow Step
      // history.replace(`/dashboard/workflow-runs/${workflowRunId}/steps/${workflowStepId}`);
      navigate(`/dashboard/workflow-runs/${workflowRunId}`, { replace: true });
    }
  }, [workflowRunId]);

  if (isLoading) {
    return (
      <Backdrop>
        <LoadingIndicator fullscreen={true} />
      </Backdrop>
    );
  }

  if (error) {
    return (
      <Backdrop>
        <NullState
          message='The Workflow Step you are looking for does not exist or is not available to you.'
          backRoute='/dashboard/workflow-runs'
        />
      </Backdrop>
    );
  }

  return <></>;
};

export default DashboardWorkflowRunStepsRoute;
